(function () {
  'use strict';

  if (window.__VSKLO_JUDGEME_LOCALE_V1__) return;
  window.__VSKLO_JUDGEME_LOCALE_V1__ = true;

  var script = document.currentScript;
  var labels = {
    title: script && script.dataset.title || '',
    first: script && script.dataset.first || '',
    write: script && script.dataset.write || '',
    none: script && script.dataset.none || ''
  };

  // Suppress the four localized "No reviews" labels, including those re-injected
  // by Judge.me after Liquid rendering. We never alter actual review counts.
  var noReviewLabels = new Set([
    labels.none, 'Немає відгуків', 'Немає відгуку', 'No reviews',
    'Brak opinii', 'Keine Bewertungen'
  ].filter(Boolean).map(function (v) {
    return String(v).replace(/\s+/g, ' ').trim().toLowerCase();
  }));

  var exactMap = new Map([
    ['Відгуки клієнтів', labels.title],
    ['Відгуки', labels.title],
    ['Reviews', labels.title],
    ['Customer reviews', labels.title],
    ['Будьте першим, хто напише відгук', labels.first],
    ['Be the first to write a review', labels.first],
    ['Написати відгук', labels.write],
    ['Write a review', labels.write]
  ]);

  function translateElement(el) {
    if (!el || !el.closest || !el.closest('.jdgm-widget')) return;

    // Some Judge.me badge templates append the fallback as a bare text node
    // next to a rating-stars child. Clear that node without touching stars.
    if (el.childNodes) {
      el.childNodes.forEach(function (node) {
        if (node.nodeType !== 3) return;
        var childText = (node.nodeValue || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (noReviewLabels.has(childText)) node.nodeValue = '';
      });
    }

    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;
    if (noReviewLabels.has(text.toLowerCase())) {
      if (!el.children || !el.children.length) {
        el.textContent = '';
        el.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    var replacement = exactMap.get(text);
    if (!replacement || replacement === text) return;
    if (el.children && el.children.length) return;
    el.textContent = replacement;
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.nodeType === 1) translateElement(root);
    var inWidget = root.nodeType === 1 && root.closest('.jdgm-widget');
    root.querySelectorAll(inWidget ? '*' : '.jdgm-widget, .jdgm-widget *').forEach(translateElement);
  }

  scan(document);

  var pending = new Set();
  var scanScheduled = false;
  function queueScan(node) {
    if (!node || !node.isConnected) return;
    pending.add(node);
    if (scanScheduled) return;
    scanScheduled = true;
    window.requestAnimationFrame(function () {
      scanScheduled = false;
      var targets = Array.from(pending);
      pending.clear();
      targets.forEach(function (target) {
        if (target.isConnected) scan(target);
      });
    });
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') {
        var parent = mutation.target.parentElement;
        if (parent && parent.closest('.jdgm-widget')) queueScan(parent);
        return;
      }

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 3) {
          var parent = node.parentElement;
          if (parent && parent.closest('.jdgm-widget')) queueScan(parent);
          return;
        }
        if (node.nodeType !== 1) return;
        if (node.matches('.jdgm-widget') || node.closest('.jdgm-widget')) {
          queueScan(node);
        } else {
          node.querySelectorAll('.jdgm-widget').forEach(queueScan);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
